module.exports = __webpack_public_path__ + "img/91ad417136d26f0b032cbd0e3267f1b5.png";